import React from 'react';
import {
    Box,
    Step,
    StepContent,
    StepLabel,
    Stepper,
    Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

type Props = {
    steps: {
        label: string;
        component?: React.ReactNode;
    }[];
};

const StepperGeneral = ({ steps }: Props) => {
    const { activeStep } = useSelector((state: RootState) => state.general);

    return (
        <Box sx={{ mt: 3 }}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                    <Step key={step.label}>
                        <StepLabel
                            optional={
                                index === 2 ? (
                                    <Typography variant="caption">
                                        Last step
                                    </Typography>
                                ) : null
                            }
                        >
                            {step.label}
                        </StepLabel>
                        <StepContent>
                            <br />
                            {step.component && step.component}
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};

export default StepperGeneral;
